(function () {
    angular
        .module("app")
        .service("DataService", DataService);

    DataService.$inject = ["appConfig"];

    function DataService(appConfig) {

        var svc = {};
        window._appConfig = appConfig;

        svc.loadPropsAndMethods = function(callerScope) {

            callerScope.searchBucketConfig = appConfig.searchParams.searchViews;

            callerScope.currentSearch = {
                searchResults: [],
                popularResults: [],
                fetchSize: 10,
                pageSize: 10,
                resultsCount: 0,
                currentPage: 1,
                errorMessage: null,
                searchResultsCountMessage: '',
                loading: false,
                showingFrom:0,
                showingTo:0,
                showingRange:'',
                shroud: false,
                searchParams:{}
            };

            callerScope.displaySearch = {
                searchResults: [],
                popularResults: [],
                fetchSize: 10,
                pageSize: 10,
                resultsCount: 0,
                currentPage: 1,
                errorMessage: null,
                searchResultsCountMessage: '',
                loading: false,
                showingFrom:0,
                showingTo:0,
                showingRange:''
            };


            callerScope.enSynonyms = appConfig.enSynonyms || '';
            callerScope.showItemStats = appConfig.searchParams.showItemStats || false;
            callerScope.searchMultipleViews = appConfig.searchParams.searchMultipleViews || false;
            callerScope.apiUrl = appConfig.searchParams.apiUrls[appConfig.gsaTier];
            callerScope.arcgisSearchExtensionParams = appConfig.arcgisSearchExtensionParams;


            callerScope.currentSearchToDisplay = function (){
                setTimeout(function(){ },1);
                callerScope.displaySearch.searchResults = callerScope.currentSearch.searchResults;
                callerScope.displaySearch.popularResults = callerScope.currentSearch.popularResults;
                    callerScope.displaySearch.fetchSize = callerScope.currentSearch.fetchSize;
                    callerScope.displaySearch.pageSize = callerScope.currentSearch.pageSize;
                    callerScope.displaySearch.resultsCount = callerScope.currentSearch.resultsCount;
                    callerScope.displaySearch.searchResultsCountMessage = callerScope.currentSearch.searchResultsCountMessage;
                    callerScope.displaySearch.currentPage = callerScope.currentSearch.currentPage;
                    callerScope.displaySearch.errorMessage = callerScope.currentSearch.errorMessage;
                    callerScope.displaySearch.loading = callerScope.currentSearch.loading;
                    callerScope.displaySearch.showingFrom = callerScope.currentSearch.showingFrom;
                    callerScope.displaySearch.showingTo = callerScope.currentSearch.showingTo;
                    callerScope.displaySearch.showingRange = callerScope.currentSearch.showingRange;

            };


            callerScope.getBucketCollectionData = function (url) {
                var _url = url,
                    _views = appConfig.searchParams.searchViewCollectionData;
                if(typeof _url.indexOf === "function"){
                    for (var i = 0; i < _views.length; i++) {
                        if (_views[i].urls.find(u => _url.indexOf(u) > -1)) {
                            return {collectionCategory: _views[i].collectionCategory};
                        }
                    }
                }
                return {collectionCategory: ""};
            }



            // TODO: remove localStorage functions and references.
            callerScope.localStorage = {

                showCurrentSearchItems: function(){
                    const showSearchResults = JSON.parse(localStorage.getItem("cs_searchResults"));
                    //console.log('showSearchResults',showSearchResults)
                },



                setCurrentSearchItems: function(){

                    if (typeof window.localStorage != "undefined") {
                        localStorage.setItem("windowLocationHash", window.location.hash);
                        const _searchResultsCount = callerScope.searchResultsCount || "";
                        localStorage.setItem("searchResultsCount", _searchResultsCount );
                        localStorage.setItem("cs_searchResults", JSON.stringify(callerScope.currentSearch.searchResults));
                        localStorage.setItem("cs_fetchSize", callerScope.currentSearch.fetchSize);
                        localStorage.setItem("cs_pageSize", callerScope.currentSearch.pageSize);
                        localStorage.setItem("cs_resultsCount", callerScope.currentSearch.resultsCount);
                        localStorage.setItem("cs_currentPage", callerScope.currentSearch.currentPage);
                        localStorage.setItem("cs_showingFrom", callerScope.currentSearch.showingFrom);
                        localStorage.setItem("cs_showingTo", callerScope.currentSearch.showingTo);
                        localStorage.setItem("cs_noResults", callerScope.currentSearch.noResults);
                        localStorage.setItem("cs_didSearch", callerScope.currentSearch.didSearch);
                        localStorage.setItem("cs_errorMessage", callerScope.currentSearch.errorMessage);
                        //callerScope.toConsole.log('setCurrentSearchItems')
                    }
                },
                getCurrentSearchItems: function(){

                    if (typeof window.localStorage != "undefined") {
                        callerScope.searchResultsCount = localStorage.getItem("searchResultsCount") || "";
                        callerScope.currentSearch.searchResults = JSON.parse(localStorage.getItem("cs_searchResults"));
                        callerScope.currentSearch.fetchSize = localStorage.getItem("cs_fetchSize");
                        callerScope.currentSearch.pageSize = localStorage.getItem("cs_pageSize");
                        callerScope.currentSearch.resultsCount = localStorage.getItem("cs_resultsCount");
                        callerScope.currentSearch.currentPage = localStorage.getItem("cs_currentPage");
                        callerScope.currentSearch.showingFrom = localStorage.getItem("cs_showingFrom");
                        callerScope.currentSearch.showingTo = localStorage.getItem("cs_showingTo");
                        callerScope.currentSearch.noResults = localStorage.getItem("cs_noResults");
                        callerScope.currentSearch.didSearch = localStorage.getItem("cs_didSearch");
                        callerScope.currentSearch.errorMessage = localStorage.getItem("cs_errorMessage");
                    }
                },
                getDisplaySearchItems: function(){

                    if (typeof window.localStorage != "undefined") {
                        callerScope.searchResultsCount = localStorage.getItem("searchResultsCount") || "";
                        callerScope.displaySearch.searchResults = JSON.parse(localStorage.getItem("cs_searchResults"));
                        callerScope.displaySearch.fetchSize = localStorage.getItem("cs_fetchSize");
                        callerScope.displaySearch.pageSize = localStorage.getItem("cs_pageSize");
                        callerScope.displaySearch.resultsCount = localStorage.getItem("cs_resultsCount");
                        callerScope.displaySearch.currentPage = localStorage.getItem("cs_currentPage");
                        callerScope.displaySearch.showingFrom = localStorage.getItem("cs_showingFrom");
                        callerScope.displaySearch.showingTo = localStorage.getItem("cs_showingTo");
                        callerScope.displaySearch.noResults = localStorage.getItem("cs_noResults");
                        callerScope.displaySearch.didSearch = localStorage.getItem("cs_didSearch");
                        callerScope.displaySearch.errorMessage = localStorage.getItem("cs_errorMessage");
                    }
                },
                removeCurrentSearchItems: function(){
                    
                    if (typeof window.localStorage != "undefined") {
                        localStorage.removeItem("windowLocationHash");
                        localStorage.removeItem("searchResultsCount");
                        localStorage.removeItem("cs_searchResults");
                        localStorage.removeItem("cs_fetchSize");
                        localStorage.removeItem("cs_pageSize");
                        localStorage.removeItem("cs_resultsCount");
                        localStorage.removeItem("cs_currentPage");
                        localStorage.removeItem("cs_showingFrom");
                        localStorage.removeItem("cs_showingTo");
                        localStorage.removeItem("cs_noResults");
                        localStorage.removeItem("cs_didSearch");
                        localStorage.removeItem("cs_errorMessage");
                    }
                }
            };



        };
        
        return svc;
    }


})();
